export default __webpack_public_path__ + "static/media/commentDark.a7714629.svg";